import Axios from "axios";

let ApiClient = Axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
  headers: { Accept: "application/json" }
});

export default ApiClient;
